"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.combineFlightProducts = combineFlightProducts;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _searchRequest = _interopRequireDefault(require("./search-request.factory"));
var _itinerary = _interopRequireDefault(require("./itinerary.factory"));
var _luggage = _interopRequireDefault(require("./luggage.factory"));
var _ssr = _interopRequireDefault(require("./ssr.factory"));
var _brandedFares = require("./branded-fares.factory");
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _last3 = _interopRequireDefault(require("lodash/last"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _segment = require("../utils/segment.utils");
var _leg = require("../utils/leg.utils");
var _searchResults = require("../utils/search-results.utils");
var _traveller = require("../utils/traveller.utils");
var _pax = require("../utils/pax.utils");
var _itinerary2 = require("../utils/itinerary.utils");
var _combinedItinerary = _interopRequireDefault(require("./combined-itinerary.factory"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function flightProductFactory(_ref) {
  var _flightProduct$additi, _flightProduct$additi2, _flightProduct$option, _flightProduct$option2, _flightProduct$additi3, _flightProduct$additi4, _flightProduct$option3, _flightProduct$option4, _flightProduct$travel, _flightProduct$option5, _flightProduct$option6, _flightProduct$option7, _flightProduct$option8, _searchRequest$isRoun, _flightProduct$option9, _flightProduct$option10, _flightProduct$option11, _flightProduct$option12, _flightProduct$option13, _flightProduct$option14, _flightProduct$option15, _flightProduct$additi5, _flightProduct$additi6, _flightProduct$additi7, _last2, _luggageInfo$, _flightProduct$additi8, _flightProduct$additi9, _flightProduct$additi10, _flightProduct$additi11, _flightProduct$additi12, _flightProduct$additi13, _flightProduct$additi14, _flightProduct$additi15, _flightProduct$additi16, _flightProduct$additi17, _flightProduct$option16, _flightProduct$option17;
  var flightProduct = _ref.flightProduct,
    $currency = _ref.$currency;
  var query = (_flightProduct$additi = flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi2 = flightProduct.additionalData) === null || _flightProduct$additi2 === void 0 ? void 0 : _flightProduct$additi2.query) !== null && _flightProduct$additi !== void 0 ? _flightProduct$additi : "";
  var vendor = flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.vendorName;
  var searchRequest = (0, _searchRequest.default)(query);
  var segmentHashMap = (0, _segment.generateSegmentHashMap)({
    segments: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option = flightProduct.options) === null || _flightProduct$option === void 0 ? void 0 : _flightProduct$option.segment,
    searchRequest: searchRequest
  });
  var segments = (0, _values2.default)(segmentHashMap);
  var legHashMap = (0, _leg.generateLegHashMap)({
    legs: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option2 = flightProduct.options) === null || _flightProduct$option2 === void 0 ? void 0 : _flightProduct$option2.leg,
    segmentHashMap: segmentHashMap,
    searchRequest: searchRequest
  });
  var itineraryPayload = itineraryPayloadFactory(flightProduct);
  var itinerary = (0, _itinerary.default)({
    itinerary: itineraryPayload,
    legHashMap: legHashMap,
    searchRequest: searchRequest,
    $currency: $currency
  });
  var airlineCodes = (0, _searchResults.extractSearchAirlineCodes)(segments);
  var airportCodes = (0, _searchResults.extractSearchAirportCodes)({
    segments: segments,
    searchRequest: searchRequest
  });
  var ssr = (0, _map2.default)((_flightProduct$additi3 = flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi4 = flightProduct.additionalData) === null || _flightProduct$additi4 === void 0 ? void 0 : _flightProduct$additi4.ssr) !== null && _flightProduct$additi3 !== void 0 ? _flightProduct$additi3 : [], function (ssr) {
    return (0, _ssr.default)({
      ssr: ssr,
      $currency: $currency,
      productId: flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.id
    });
  });
  var travellers = (0, _traveller.getFlightTravellers)({
    pax: (_flightProduct$option3 = flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option4 = flightProduct.options) === null || _flightProduct$option4 === void 0 ? void 0 : _flightProduct$option4.pax) !== null && _flightProduct$option3 !== void 0 ? _flightProduct$option3 : [],
    travellers: (_flightProduct$travel = flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.traveller) !== null && _flightProduct$travel !== void 0 ? _flightProduct$travel : [],
    ssr: ssr,
    hasFrequentFlyerOptions: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option5 = flightProduct.options) === null || _flightProduct$option5 === void 0 ? void 0 : _flightProduct$option5.hasFrequentFlyerOptions,
    hasMealOptions: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option6 = flightProduct.options) === null || _flightProduct$option6 === void 0 ? void 0 : _flightProduct$option6.hasMealOptions,
    $currency: $currency,
    vendor: vendor
  });
  var luggageInfo = (0, _map2.default)((_flightProduct$option7 = flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option8 = flightProduct.options) === null || _flightProduct$option8 === void 0 ? void 0 : _flightProduct$option8.luggage) !== null && _flightProduct$option7 !== void 0 ? _flightProduct$option7 : [], function (luggage) {
    return (0, _luggage.default)({
      luggage: luggage,
      $currency: $currency,
      productId: flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.id
    });
  });
  var isSeatReserved = (0, _get2.default)(flightProduct, "additionalData.isSeatReserved", false);
  var isRoundTrip = (_searchRequest$isRoun = searchRequest === null || searchRequest === void 0 ? void 0 : searchRequest.isRoundTrip) !== null && _searchRequest$isRoun !== void 0 ? _searchRequest$isRoun : false;
  var fareItineraries = (_flightProduct$option9 = flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option10 = flightProduct.options) === null || _flightProduct$option10 === void 0 ? void 0 : (_flightProduct$option11 = _flightProduct$option10.fareFamilyOptions) === null || _flightProduct$option11 === void 0 ? void 0 : _flightProduct$option11.itineraries) !== null && _flightProduct$option9 !== void 0 ? _flightProduct$option9 : [];
  var hasFareFamilyExpired = (flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option12 = flightProduct.options) === null || _flightProduct$option12 === void 0 ? void 0 : _flightProduct$option12.fareFamilyOptions) === null;
  var fareFamilyOptions = hasFareFamilyExpired ? [] : (0, _itinerary2.getFareFamilyOptions)({
    fareItineraries: fareItineraries,
    itineraryId: itinerary === null || itinerary === void 0 ? void 0 : itinerary.id,
    isRoundTrip: isRoundTrip,
    $currency: $currency
  });
  var brandedFaresOptions = (_flightProduct$option13 = flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option14 = flightProduct.options) === null || _flightProduct$option14 === void 0 ? void 0 : (_flightProduct$option15 = _flightProduct$option14.fareFamilyOptions) === null || _flightProduct$option15 === void 0 ? void 0 : _flightProduct$option15.brandedFares) !== null && _flightProduct$option13 !== void 0 ? _flightProduct$option13 : {};
  var brandedFares = (0, _mapValues2.default)(brandedFaresOptions, function (fares, code) {
    return (0, _brandedFares.brandedFaresFactory)({
      fares: fares,
      code: code,
      $currency: $currency
    });
  });
  var availableAddOns = (0, _filter2.default)(flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi5 = flightProduct.additionalData) === null || _flightProduct$additi5 === void 0 ? void 0 : _flightProduct$additi5.availableAddOns, function (addon) {
    return !!_constants.ADDONS[addon.code];
  });
  var fareUuid = (_flightProduct$additi6 = flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi7 = flightProduct.additionalData) === null || _flightProduct$additi7 === void 0 ? void 0 : _flightProduct$additi7.fareUuid) !== null && _flightProduct$additi6 !== void 0 ? _flightProduct$additi6 : "";
  return {
    id: flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.id,
    query: query,
    itinerary: itinerary,
    searchRequest: searchRequest,
    vendor: vendor,
    lastDepartureDate: (_last2 = (0, _last3.default)(searchRequest.leg)) === null || _last2 === void 0 ? void 0 : _last2.departure,
    fareUuid: fareUuid,
    carriers: (0, _map2.default)(itinerary === null || itinerary === void 0 ? void 0 : itinerary.legs, "validatingCarrier"),
    airlineCodes: airlineCodes,
    airportCodes: airportCodes,
    resourceCodes: [].concat(airportCodes, airlineCodes),
    travellers: travellers,
    ssr: ssr,
    luggageInfo: luggageInfo,
    baggageInfo: (0, _pax.getFlightBaggageInfo)({
      luggageInfo: luggageInfo,
      baggageInfo: itinerary.baggageInfo,
      productId: flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.id
    }),
    canAddExtraBaggage: (0, _size2.default)(luggageInfo === null || luggageInfo === void 0 ? void 0 : (_luggageInfo$ = luggageInfo[0]) === null || _luggageInfo$ === void 0 ? void 0 : _luggageInfo$.options) > 0,
    freeBaggageAvailable: (0, _some2.default)(luggageInfo, function (extraBaggage) {
      return !!(extraBaggage !== null && extraBaggage !== void 0 && extraBaggage.freeBaggageAvailable);
    }),
    extraBaggageTotals: (0, _pax.getExtraBaggageTotals)({
      travellers: travellers,
      $currency: $currency
    }),
    isSeatReserved: isSeatReserved,
    isSealed: isSeatReserved,
    isDisableContactForm: isSeatReserved && (flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi8 = flightProduct.additionalData) === null || _flightProduct$additi8 === void 0 ? void 0 : (_flightProduct$additi9 = _flightProduct$additi8.uiControls) === null || _flightProduct$additi9 === void 0 ? void 0 : _flightProduct$additi9.disableContactForm),
    isDisableTravellersForm: isSeatReserved && (flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi10 = flightProduct.additionalData) === null || _flightProduct$additi10 === void 0 ? void 0 : (_flightProduct$additi11 = _flightProduct$additi10.uiControls) === null || _flightProduct$additi11 === void 0 ? void 0 : _flightProduct$additi11.disableTravellersForm),
    isDisableSSRForm: isSeatReserved && (flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi12 = flightProduct.additionalData) === null || _flightProduct$additi12 === void 0 ? void 0 : (_flightProduct$additi13 = _flightProduct$additi12.uiControls) === null || _flightProduct$additi13 === void 0 ? void 0 : _flightProduct$additi13.disableSSRForm),
    isV3Pricing: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi14 = flightProduct.additionalData) === null || _flightProduct$additi14 === void 0 ? void 0 : _flightProduct$additi14.isV3Pricing,
    isV3Search: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi15 = flightProduct.additionalData) === null || _flightProduct$additi15 === void 0 ? void 0 : _flightProduct$additi15.isV3Search,
    airlineReference: flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.supplierConfirmationNumber,
    availableAddOns: availableAddOns,
    addOnProducts: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi16 = flightProduct.additionalData) === null || _flightProduct$additi16 === void 0 ? void 0 : _flightProduct$additi16.addOnProducts,
    disclaimersQuery: (0, _pax.getDisclaimersQuery)(itinerary),
    currency: $currency.currentCurrency,
    brandedFares: brandedFares,
    hasFareFamilyExpired: hasFareFamilyExpired,
    fareFamilyOptions: fareFamilyOptions,
    upgradeFareExtraAmount: (0, _itinerary2.getUpgradeFareExtraAmount)(fareFamilyOptions, $currency),
    additionalData: flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.additionalData,
    options: flightProduct === null || flightProduct === void 0 ? void 0 : flightProduct.options,
    direction: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$additi17 = flightProduct.additionalData) === null || _flightProduct$additi17 === void 0 ? void 0 : _flightProduct$additi17.direction,
    hasFrequentFlyerOptions: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option16 = flightProduct.options) === null || _flightProduct$option16 === void 0 ? void 0 : _flightProduct$option16.hasFrequentFlyerOptions,
    hasMealOptions: flightProduct === null || flightProduct === void 0 ? void 0 : (_flightProduct$option17 = flightProduct.options) === null || _flightProduct$option17 === void 0 ? void 0 : _flightProduct$option17.hasMealOptions,
    isMultiPNR: false,
    vendors: [vendor],
    fareUuids: [fareUuid]
  };
}
function combineFlightProducts(flightProducts, $currency) {
  if (flightProducts.length === 0) {
    throw new Error("No flight products to combine");
  }
  var outboundFlightProduct = (0, _find2.default)(flightProducts, function (fp) {
    return fp.direction === "outbound";
  });
  var inboundFlightProduct = (0, _find2.default)(flightProducts, function (fp) {
    return fp.direction === "inbound";
  });
  var products = [outboundFlightProduct, inboundFlightProduct];
  var itinerary = (0, _combinedItinerary.default)({
    outbound: outboundFlightProduct.itinerary,
    inbound: inboundFlightProduct.itinerary,
    $currency: $currency
  });
  itinerary.isMultiPNR = true;
  var luggageInfo = products.flatMap(function (fp) {
    return fp.luggageInfo.map(function (luggage) {
      return _objectSpread(_objectSpread({}, luggage), {}, {
        isFullTrip: false
      });
    });
  });
  var hasFrequentFlyerOptions = (0, _some2.default)(products, function (fp) {
    return fp.hasFrequentFlyerOptions;
  });
  var hasMealOptions = (0, _some2.default)(products, function (fp) {
    return fp.hasMealOptions;
  });
  var travellers = (0, _map2.default)(outboundFlightProduct.travellers, function (traveller, index) {
    var inboundLuggage = (0, _get2.default)(inboundFlightProduct, "travellers." + index + ".ssr.luggage", {});
    var outboundLuggage = (0, _get2.default)(traveller, "ssr.luggage", {});
    var luggage = _objectSpread(_objectSpread({}, outboundLuggage), inboundLuggage);
    return _objectSpread(_objectSpread({}, traveller), {}, {
      hasFrequentFlyerOptions: hasFrequentFlyerOptions && !traveller.isInfant,
      hasMealOptions: hasMealOptions && !traveller.isInfant,
      products: multiProductSsrFactory({
        outboundFlightProduct: outboundFlightProduct,
        inboundFlightProduct: inboundFlightProduct,
        isInfant: traveller.isInfant,
        index: index
      }),
      ssr: _objectSpread(_objectSpread({}, traveller.ssr), {}, {
        luggage: luggage
      })
    });
  });
  return _objectSpread(_objectSpread({}, outboundFlightProduct), {}, {
    id: (0, _map2.default)(products, function (fp) {
      return fp.id;
    }).join(_constants.DOMESTIC_ID_SEPARATOR),
    itinerary: itinerary,
    luggageInfo: luggageInfo,
    travellers: travellers,
    hasMealOptions: hasMealOptions,
    hasFrequentFlyerOptions: hasFrequentFlyerOptions,
    fareUuids: (0, _map2.default)(products, function (fp) {
      return fp.fareUuid;
    }),
    vendors: (0, _map2.default)(products, function (fp) {
      return fp.vendor;
    }),
    carriers: (0, _flatMap2.default)(products, function (fp) {
      return fp.carriers;
    }),
    airlineCodes: Array.from(new Set((0, _flatMap2.default)(products, function (fp) {
      return fp.airlineCodes;
    }))),
    airportCodes: Array.from(new Set((0, _flatMap2.default)(products, function (fp) {
      return fp.airportCodes;
    }))),
    resourceCodes: Array.from(new Set((0, _flatMap2.default)(products, function (fp) {
      return fp.resourceCodes;
    }))),
    freeBaggageAvailable: (0, _some2.default)(products, function (fp) {
      return fp.freeBaggageAvailable;
    }),
    ssr: (0, _flatMap2.default)(products, function (fp) {
      return fp.ssr;
    }),
    baggageInfo: (0, _flatMap2.default)(products, function (fp) {
      return (0, _map2.default)(fp.baggageInfo, function (baggage) {
        return _objectSpread(_objectSpread({}, baggage), {}, {
          isFullTrip: false
        });
      });
    }),
    canAddExtraBaggage: (0, _some2.default)(luggageInfo, function (luggage) {
      return luggage.options.length > 0;
    }),
    disclaimersQuery: (0, _pax.getDisclaimersQuery)(itinerary),
    brandedFares: Object.assign.apply(Object, [{}].concat((0, _map2.default)(products, function (fp) {
      return fp.brandedFares;
    }))),
    isMultiPNR: true
  });
}
function itineraryPayloadFactory(flightProduct) {
  return {
    id: (0, _get2.default)(flightProduct, "additionalData.itineraryId"),
    cid: (0, _get2.default)(flightProduct, "additionalData.cid"),
    path: [],
    legId: (0, _map2.default)((0, _get2.default)(flightProduct, "options.leg"), "id"),
    flightCodes: (0, _get2.default)(flightProduct, "options.flightCodes"),
    price: {
      totals: (0, _get2.default)(flightProduct, "price")
    },
    fare: (0, _get2.default)(flightProduct, "options.fare"),
    validatingCarrier: (0, _get2.default)(flightProduct, "additionalData.validatingCarrier"),
    vendor: (0, _get2.default)(flightProduct, "vendorName"),
    containsDifferentCabin: (0, _get2.default)(flightProduct, "options.containsDifferentCabin"),
    ticketScenario: (0, _get2.default)(flightProduct, "options.ticketScenario", ""),
    hasFareFamilies: (0, _get2.default)(flightProduct, "options.hasFareFamilies", false)
  };
}
function multiProductSsrFactory(_ref2) {
  var _ref3;
  var outboundFlightProduct = _ref2.outboundFlightProduct,
    inboundFlightProduct = _ref2.inboundFlightProduct,
    isInfant = _ref2.isInfant,
    index = _ref2.index;
  return _ref3 = {}, _ref3[outboundFlightProduct.id] = {
    ssr: _objectSpread({}, (0, _get2.default)(outboundFlightProduct, "travellers." + index + ".ssr", {})),
    isFrequentFlyerValid: outboundFlightProduct.hasFrequentFlyerOptions && !isInfant,
    isMealValid: outboundFlightProduct.hasMealOptions && !isInfant,
    productId: outboundFlightProduct.id,
    originId: (0, _get2.default)(outboundFlightProduct, "itinerary.firstLeg.originId", ""),
    destinationId: (0, _get2.default)(outboundFlightProduct, "itinerary.firstLeg.destinationId", ""),
    validatingCarrier: (0, _get2.default)(outboundFlightProduct, "itinerary.validatingCarrier", "")
  }, _ref3[inboundFlightProduct.id] = {
    ssr: _objectSpread({}, (0, _get2.default)(inboundFlightProduct, "travellers." + index + ".ssr", {})),
    isFrequentFlyerValid: inboundFlightProduct.hasFrequentFlyerOptions && !isInfant,
    isMealValid: inboundFlightProduct.hasMealOptions && !isInfant,
    productId: inboundFlightProduct.id,
    originId: (0, _get2.default)(inboundFlightProduct, "itinerary.firstLeg.originId", ""),
    destinationId: (0, _get2.default)(inboundFlightProduct, "itinerary.firstLeg.destinationId", ""),
    validatingCarrier: (0, _get2.default)(inboundFlightProduct, "itinerary.validatingCarrier", "")
  }, _ref3;
}
var _default = exports.default = flightProductFactory;